<template>
  <div v-if="menu && !pagesLoading">
    <page-header :header="menu.name" />
    <div v-if="menuPages.length > 0" class="flex flex-wrap -mx-6 -mt-6">
      <div
        v-for="page in menuPages"
        :key="page.id"
        class="w-full md:w-1/2 xl:w-1/3 mt-6"
      >
        <div
          class="flex flex-col bg-white rounded-lg mb-2 mx-6 mt-10 p-4 md:p-6 cursor-pointer h-80"
          @click="$router.push(`${menu.slug}/${page.slug}`)"
        >
          <div class="flex-no-shrink flex items-start mb-2 md:mb-4 pb-4 border-b">
            <div
              class="w-32 h-32 p-4 -mt-12 rounded-lg relative flex-no-shrink text-white"
              :class="page.icon_color ? page.icon_color : 'bg-tertiary'"
            >
              <icon v-if="page.icon" :name="page.icon" class="text-white" />
              <icon v-else name="information_circle" class="text-white" />
            </div>
            <div class="relative w-full">
              <div class="absolute pin-t pin-r rounded-full bg-white -mt-10 -mr-3 w-8 h-8 flex items-center justify-center shadow" v-if="page.product_config && page.product_config.page_type === 'order-history' && marketingPackNotifications.notifications">
                <div class="absolute pin-t pin-r -mt-2 -mr-2 bg-yellow-dark px-2 p-1 rounded-full text-xs text-white">
                  {{ marketingPackNotifications.notifications }}
                </div>
                <i class="fas fa-bell text-yellow-dark"></i>
              </div>
              <div class="ml-4 mb-4 text-2xl font-medium">{{ page.title }}</div>
            </div>
          </div>
          <div class="mt-2 overflow-x-hidden overflow-y-auto">
            <p class="leading-normal">{{ page.intro }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else  class="w-full flex flex-col md:flex-row items-center">
      <div class="w-full md:w-1/2 text-center">
        <h1 class="text-5xl font-thin mb-6 text-center">
          Urm...
        </h1>
        <h2 class="text-3xl font-normal mb-12">
          Looks like we've not added any pages here yet
        </h2>
        <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
          Take me home
        </router-link>
      </div>
    </div>
  </div>
  <div v-else-if="notFound && !pagesLoading" class="flex flex-wrap pt-10 -mx-6 -mt-6">
   <div  class="w-full flex flex-col md:flex-row items-center">
    <div class="w-full md:w-1/2 text-center">
      <h1 class="text-5xl font-thin mb-6 text-center">
        Urm...
      </h1>
      <h2 class="text-3xl font-normal mb-12">
        Page not found
      </h2>
      <router-link to="/" class="inline-block no-underline text-black text-1xl font-normal bg-white rounded shadow px-4 py-3 hover:shadow-none">
        Take me home
      </router-link>
    </div>
  </div>
  </div>
  <loader v-else/>

</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { find } from 'lodash'

export default {
  data () {
    return {
      menu: null,
      menuPages: [],
      notFound: false

    }
  },

  computed: {
    ...mapGetters(['getMenuPages', 'allMenus']),
    ...mapState(['selectedOffice', 'pages', 'pagesLoading', 'marketingPackNotifications'])
  },

  methods: {
    ...mapActions(['fetchMarketingPackNotifications']),
    load () {
      this.menu = find(this.allMenus, m => m.slug === 'marketing-packs')
      if (!this.menu) {
        this.notFound = true
        return
      }
      this.menuPages = this.getMenuPages(this.menu)
    }
  },

  created () {
    this.fetchMarketingPackNotifications()
    this.load()
  },

  watch: {
    '$route' (to, from) {
      this.load()
    },
    allMenus () {
      this.load()
    },
    pages () {
      this.load()
    },
    selectedOffice () {
      this.menuPages = this.getMenuPages(this.menu)
    }
  }
}
</script>
